// NOTE: hooks
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
// NOTE: components
import NavBar from './navBar/NavBar'
import Footer from './Footer'

const Layout = () => {
	const { pathname, hash } = useLocation()

	useEffect(() => {
		if (!hash) window.scrollTo(0, 0)
	}, [pathname, hash])

	return (
		<div className="flex min-h-screen flex-col">
			<NavBar />
			<main id="main" className="flex-1">
				<Outlet />
			</main>
			<Footer />
		</div>
	)
}

export default Layout
